'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  REG_A: 'Reg. A+',
  REG_D: 'Reg. D',
  REG_CF: 'Reg. CF',
  Reg_D_506b: 'Reg. D - 506(b)',
  Reg_D_504: 'Reg. D - 504',
  Reg_D_506c: 'Reg. D - 506(c)',
  Reg_S: 'Reg S',
  Rule_147: 'Rule 147',
  Rule_147A: 'Rule 147A',
  Rule_144: 'Rule 144',
  Rule_144A: 'Rule 144A'
});